export const enum LOGIN_MODAL {
  LOGIN_HELP = 'login help',
  LOG_IN = 'log in',
  JOIN_SKYMILES = 'join skymiles',
  FORGOT_LOGIN = 'forgot skymiles number',
  FORGOT_PASSWORD = 'forgot password',
  RESET_PASSWORD = 'reset password',
  RESET_CREATE_PASSWORD = 'reset/create password',
  MY_TRIPS = 'my trips',
  SEND_LOGIN = 'send login',
  SECURITY_QUESTIONS = 'security questions:continue',
  CHECK_YOUR_EMAIL = 'email:continue'
}
export const enum ACCOUNT_RECOVERY_PAGES {
  GLOBAL_HEADER = 'global header login modal',
  CENTER_PAGE = 'center page login modal',
  STANDALONE = 'standalone login page',
  FORGOT_LOGIN = 'forgot login',
  UNLOCK_ACCOUNT = 'unlock account',
  LOGIN_HELP = 'login help',
  RECOVERY_METHOD = 'recovery method',
  RESET_PASSWORD = 'reset password',
  CHECK_YOUR_EMAIL = 'check your email'
}
export const enum VIEW_PAGE {
  FORGOT_LOGIN = 'forgotlogin',
  LOG_IN = 'login',
  FORGOT_PASSWORD = 'resetpassword',
  JOIN_SKYMILES = 'joinskymiles',
  NEED_HELP = 'needhelp',
  LOGIN_HELP = 'loginhelp',
  MY_TRIPS = 'mytrips',
  CONTINUE = 'continue',
  SECURITY_QUESTIONS = 'securityquestionanswers',
  CHECK_YOUR_EMAIL = 'newresetpasswordcheckyouremail'
}
export const enum ACTION_NAMES {
  BUTTON = 'cta click',
  LINK = 'link click'
}
export const enum LINKS {
  SEATS_URL = '/seats/'
}

export const enum GENERIC {
  PAGELOAD = 'pageLoad',
  ERROR = 'error',
  CUSTOM = 'custom',
  SUCCESS = ': reset password success',
  LOGIN_SCREEN = 'Login Screen',
  LOGIN_LEGACY_PAGE_NAME = 'Login: Log In To Delta',
  LOGIN_EVENT_DETAIL_PREFIX = 'MFA: skymiles:'
}

// Extension of HEADER_MENU for profile selector
export const HEADER_MENU_PROFILE_SELECTOR = {
  NAME: 'profile selector',
  PAGE_SECTION: 'header:profile selector flyout',
  LOGOUT: {
    NAME: 'logout',
    ACTION: 'header profile selector flyout:logout cta click'
  }
} as const;

export const MFA_BOOKING_CONFIRMATION_TOOLTIP = {
  EVENT_DETAIL: 'MFA:click',
  CLICK_TYPE: 'link',
  PAGE_SECTION: 'MFA: Booking Confirmation Tooltip',
  CLOSE: {
    CLICK_NAME: 'x to close',
    ACTION: 'MFA: Booking Confirmation Tooltip:x to close:link click'
  },
  ADD_RECOVERY: {
    CLICK_NAME: 'add recovery methods',
    ACTION: 'MFA: Booking Confirmation Tooltip:add recovery methods:link click'
  }
};
